import { render, staticRenderFns } from "./ApprovalTimeline.vue?vue&type=template&id=0ecba5da&scoped=true&"
import script from "./ApprovalTimeline.vue?vue&type=script&lang=js&"
export * from "./ApprovalTimeline.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalTimeline.vue?vue&type=style&index=0&id=0ecba5da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecba5da",
  null
  
)

export default component.exports